/** Query param discovery-kids uses to hand over its already-localized loading label. */
export const COVER_LABEL_PARAM = 'coverLabel'

/**
 * Reads the already-translated loading label discovery-kids put on its launch cover for consistent labeling.
 *
 * Returns null when an activity is opened directly rather than from the Activities tab, so the caller
 * can fall back to its own translation.
 */
export function getCoverLabel() {
  try {
    return new URLSearchParams(window.location.search).get(COVER_LABEL_PARAM) || null
  } catch {
    return null
  }
}
